export type RankCustomFieldId = string;

export const toRankCustomFieldId = (value: string): RankCustomFieldId => {
	let id = value;
	if (id.includes('customfield_', 0)) {
		[, id] = value.split('_');
	}
	return id;
};
